import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import WebService from "../../Services/WebService";
import Loader from "../Loader/Loader";
import NoDataFound from "../../assets/images/empty_item.svg";
import Pagination from "../Pagination/Pagination";
import {
  FileEarmarkArrowDown,
  FileEarmarkArrowUp,
} from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { AiOutlineEye } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";

const DeliveryBoyPayoutMonth = () => {
  const location = useLocation();
  const [vendorPayouts, setDeliveryBoyPayouts] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const initialPage = location.state?.payoutPage || 1;
  const [page, setPage] = useState(initialPage);
  const [loader, setLoader] = useState(false);
  const [currentColum, setcurrentColum] = useState("created_at");
  const [currentSort, setcurrentSort] = useState("DESC");
  const navigate = useNavigate();
  const menuList = useSelector((state: any) => state.profile.menus);
  const vendorAccess = menuList.find(
    (menu: any) => menu.name === "Delivery Boy Payouts"
  )?.access;

  useEffect(() => {
    if (initialPage) {
      setPage(initialPage);
    }
  }, []);

  const fetchDeliveryBoyPayouts = React.useCallback(
    (
      page: number,
      keyword?: string,
      status?: string
    ) => {
      setLoader(true);
      const offset = page - 1;
      const body = {
        offset: offset.toString(),
        sort_by: currentColum || "",
        sort_order: currentSort || "",
      };
      const queryParam = new URLSearchParams(body);
      WebService.getAPI({
        action: `delivery-boy-month-list?` + queryParam,
        body: null,
        isShowError: true,
      })
        .then((res: any) => {
          setDeliveryBoyPayouts(res.list);
          setTotalCount(res.count);
          setLoader(false);
        })
        .catch((error) => {
          setLoader(false);
        });
    },
    [currentColum, currentSort]
  );

  useEffect(() => {
    fetchDeliveryBoyPayouts(page);
  }, [page, currentColum, currentSort, fetchDeliveryBoyPayouts]);

  const sorting = (sort_by: any, colum_name: any) => {
    var sortBy = sort_by;
    if (currentColum !== colum_name) {
      sortBy = "DESC";
    } else {
      if (currentSort === "DESC") {
        sortBy = "ASC";
      } else {
        sortBy = "DESC";
      }
    }
    sort_by = sortBy;
    setcurrentSort(sortBy);
    setcurrentColum(colum_name);
  };

  const dynamicSortIcons = (column: string) => {
    const isActive = currentColum === column;

    return (
      <span style={{ marginLeft: "6px", color: isActive ? "#000" : "#ccc" }}>
        {isActive ? (
          currentSort === "DESC" ? (
            <FileEarmarkArrowDown size={14} />
          ) : (
            <FileEarmarkArrowUp size={14} />
          )
        ) : (
          <span style={{ display: "inline-block", transform: "rotate(90deg)" }}>
            ↕
          </span>
        )}
      </span>
    );
  };

  const handleViewUser = (weekObj: any) => {
    navigate("/delivery-boy-payouts", { state: { week: weekObj, page } });
  };

  return (
    <>
      <Container className="page-container">
        <Row className="mb-3">
          <Col>
            <h4 className="mb-4 text-primary">DeliveryBoy Payout Month List</h4>
          </Col>
        </Row>
        <Card className="card-style mb-3">
          {vendorAccess && vendorAccess.can_read === "1" ? (
            <>
              <Card.Body>

                {!loader ? (
                  <div className="border-radius table-responsive">
                    {vendorPayouts.length > 0 ? (
                      <Table responsive="sm">
                        <thead>
                          <tr>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "from_date")}
                            >
                              Month Start Date {dynamicSortIcons("from_date")}
                            </th>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "to_date")}
                            >
                              Month End Date {dynamicSortIcons("to_date")}
                            </th>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "is_current_month")}
                            >
                              Current Month {dynamicSortIcons("is_current_month")}
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendorPayouts.map((week) => (
                            <tr key={week.id}>
                              <td>{week.from_date}</td>
                              <td>{week.to_date}</td>
                              <td>{week.is_current_month === 'Y' ? 'Yes' : 'No'}</td>
                              <td>
                                <Button
                                  variant="link"
                                  className="btn btn-outline-primary btn-sm me-1"
                                  onClick={() => handleViewUser(week)}
                                >
                                  <AiOutlineEye size={18} />
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="table-wrap position-relative text-center">
                        <div className="no-data-flound">
                          <div className="text-center">
                            <img
                              src={NoDataFound}
                              width={110}
                              className="mb-3"
                              alt="No Data Found"
                            />
                            <h3 className="text-secondary font-12">
                              No Record Found
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                    <Pagination
                      pagination={10}
                      totalItems={totalCount}
                      changePage={(page: number) => setPage(page)}
                      changeCurrentPage={page}
                    />
                  </div>
                ) : (
                  <Loader show={loader} />
                )}
              </Card.Body>
            </>
          ) : (
            <>
              {" "}
              <div className="table-wrap position-relative text-center">
                <div className="no-data-flound">
                  <div className="text-center">
                    <img
                      src={NoDataFound}
                      width={110}
                      alt=""
                      className="mb-3"
                    />
                    <h3 className="text-secondary font-12">
                      Sorry, You don't have access
                    </h3>
                  </div>
                </div>
              </div>
            </>
          )}
        </Card>
      </Container>
    </>
  );
};

export default DeliveryBoyPayoutMonth;
